import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui';
import { format } from 'date-fns';
import { Trash2 } from 'lucide-react';
import { AmountDisplay } from './AmountDisplay';
import type { ITransactionDeleteModalProps } from '@/interfaces';

export const TransactionDeleteModal = ({ isOpen, onClose, transaction, onConfirm }: ITransactionDeleteModalProps) => {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="sm:max-w-[400px] duration-0 animate-none">
				<DialogHeader>
					<DialogTitle className="text-destructive">Confirmer la suppression</DialogTitle>
				</DialogHeader>

				<div className="py-4">
					<p className="text-muted-foreground">Êtes-vous sûr de vouloir supprimer cette transaction ?</p>
					{transaction && (
						<div className="mt-4 p-3 bg-muted/50 rounded-md space-y-2">
							<p className="text-sm">
								<span className="text-muted-foreground">ID:</span> <span className="font-mono">{transaction._id}</span>
							</p>
							<p className="text-sm">
								<span className="text-muted-foreground">Montant:</span>{' '}
								<AmountDisplay amount={transaction.amountEur} type={transaction.type} />
							</p>
							<p className="text-sm">
								<span className="text-muted-foreground">Date:</span>{' '}
								{format(new Date(transaction.occurredAt || transaction.createdAt || new Date()), 'dd/MM/yyyy')}
							</p>
						</div>
					)}
					<p className="mt-4 text-sm text-destructive font-medium">Cette action est irréversible.</p>
				</div>

				<DialogFooter>
					<Button variant="outline" onClick={onClose}>
						Annuler
					</Button>
					<Button variant="destructive" onClick={onConfirm}>
						<Trash2 className="h-4 w-4 mr-2" />
						Supprimer
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
